export default __webpack_public_path__ + "static/crafting_back-96dbcec156ce94f5142d608e413f0193.webp";